<div class="pageheader">
  <div class="page-title">
    <h1>Create partner</h1>
  </div>
</div>

<form (ngSubmit)="submit(form)" #form="ngForm">
  @if (newPartner) {
    <app-layout-container fixed>

      <!-- Partner name -->
      <app-layout-row>
        <app-layout-column [width]="6">
          <app-textbox decorator caption="Partner name" name="partnerName" [ngModel]="newPartner.PartnerName" required [unique]="isPartnerNameUnique"></app-textbox>
        </app-layout-column>
      </app-layout-row>

      <!-- Partner type -->
      <app-layout-row>
        <app-layout-column [width]="6">
          <app-singleselectbox decorator caption="Partner type" name="partnerType" [ngModel]="newPartner.PartnerType.Id" required [dataSource]="partnerTypes"
            valueExpr="Id" displayExpr="Name"></app-singleselectbox>
        </app-layout-column>
      </app-layout-row>

      <!-- Identification type -->
      <app-layout-row>
        <app-layout-column [width]="6">
          <app-singleselectbox decorator caption="Identification type" name="identificationType"
            [ngModel]="newPartner.MainIdentificationType.IdentificationType.IdentificationTypeId" required
            infoText="The primary type of identification used by the new partner" [dataSource]="identificationTypes" valueExpr="IdentificationTypeId"
            displayExpr="Name"></app-singleselectbox>
        </app-layout-column>
      </app-layout-row>

      <!-- Identification value -->
      <app-layout-row>
        <app-layout-column [width]="6">
          <app-textbox decorator caption="Identification" name="identificationValue" [ngModel]="newPartner.MainIdentificationType.Value" required
            infoText="The primary identification value used by the new partner"></app-textbox>
        </app-layout-column>
      </app-layout-row>

      <!-- Proxy partner -->
      <app-layout-row>
        <app-layout-column [width]="6">
          <app-checkbox decorator="right-side" caption="Proxy partner" name="proxyPartner" [ngModel]="newPartner.IsProxyPartner"></app-checkbox>
        </app-layout-column>
      </app-layout-row>

      <!-- Buttons -->
      <app-layout-row>
        <app-layout-column [width]="6">
          <div class="button-container">
            <app-button primary submit [disabled]="!form.valid">Create partner</app-button>
            <app-button secondary (buttonClick)="cancel()">Cancel</app-button>
          </div>
        </app-layout-column>
      </app-layout-row>

    </app-layout-container>
  }
</form>
